import { createAsyncThunk } from '@reduxjs/toolkit';
import createRestApiClient from '../../utils/createRestApiClient';
import get from 'lodash/get';

import { getCookieData } from '../../utils/cookieHandler/handler';
import { getEnvVar } from '../../utils/env';

export const deleteTestAction = createAsyncThunk(
  'deleteTest/deleteTestAction',
  async (data, { rejectWithValue }) => {
    try {
      const { apiUrl } = data;

      if (!apiUrl) {
        return rejectWithValue('API URL is required');
      }

      let cookieName = getEnvVar('REACT_APP_COOKIE_NAME');
      let access_token = getCookieData(cookieName);
      if (!access_token) {
        window.location.href = getEnvVar('REACT_APP_LOGIN_URL') || window?._env_?.REACT_APP_LOGIN_URL;
      }

      const mockApiClient = createRestApiClient().withConfig({
        baseURL: apiUrl,
      }).client;

      const {
        addToast = () => {},
        extendDuration = false,
        toastVariants = {},
      } = window.toast || {};

      let headers = {
        Authorization: `Bearer ${access_token}`,
        Accept: 'application/json',
      };

      const response = await mockApiClient.delete(apiUrl, {
        headers: headers,
      });

      addToast({
        message: response?.data?.message,
        variant: toastVariants.SUCCESS,
        extendDuration,
      });

      return response.data;
    } catch (error) {
      const {
        addToast = () => {},
        extendDuration = false,
        toastVariants = {},
      } = window.toast || {};

      addToast({
        message:
          error?.response?.data?.message || 'Deletion Failed, pls try again',
        variant: toastVariants.DANGER,
        extendDuration,
      });

      const errorMessage = get(
        error,
        ['response', 'data', 'message'],
        error.message || 'Failed to delete test'
      );
      return rejectWithValue(errorMessage);
    }
  }
);
